module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/complete_arrow-4c471c26767290547e451c137d5364e8.png";